import React from "react";
import { graphql } from "gatsby";
import { LinkList as LinkListComponent } from "@zempler/theme/src/components/linkList/LinkList";

export const LinkList = ({ data, ...rest }) => <LinkListComponent {...data} />;

export const LinkListQuery = graphql`
  fragment LinkList on UMBRACO_LinkListComponentType {
    items: links {
      ...Link
    }
  }
`;
